<template>
    <confirm-modal
        title="Delete library"
        cancel-button="Cancel"
        confirm-button="Delete"
        :value="value"
        max-width="640"
        @cancel="cancel"
        @confirm="confirm"
    >
        <p class="primary--text">
            <span class="warning--text"><v-icon
                class="mr-2"
                color="warning"
            >warning</v-icon>Warning! Deleting this library will permanently remove all of its videos and statistics. This action cannot be undone.</span>
        </p>
        <p>The selected library will be deleted. Would you like to confirm?</p>
        <v-list>
            <v-list-item dense>
                <v-list-item-content>
                    {{ library.name }}
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </confirm-modal>
</template>

<script>
    import ConfirmModal from './confirm-modal';

    export default {
        name: 'DeleteLibrary',
        components: {ConfirmModal},
        props: ['value', 'library'],
        methods: {
            confirm() {
                this.$emit('confirm', this.library);
                this.$emit('input', false);
            },

            cancel() {
                this.$emit('input', false);
            },
        }
    };
</script>

<style scoped>

</style>
